<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-range-picker
          @change="onChangeTime"
          :disabled="disabledAll"
          :placeholder="['开始日期', '结束日期']"
          :disabled-date="disabledDate"
          v-decorator="['ployordTime', { rules: [{ required: true, message: '请选择起始日期！' }] }]"
          :show-time="{
            hideDisabledOptions: true,
            defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
          }"
        />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <!-- 投保人 -->
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="业主">
            <a-input v-model="submitdata.salPolicyHolder.proprietorName" :disabled="disabledAll" v-decorator="['submitdata.salPolicyHolder.proprietorName', { rules: [{ required: true, message: '请输入业主名称' }] }]" placeholder="请输入业主"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="施工方">
            <a-input v-model="submitdata.salPolicyHolder.partyName" :disabled="disabledAll" v-decorator="['submitdata.salPolicyHolder.partyName', { rules: [{ required: true, message: '请输入施工方名称' }] }]" placeholder="请输入施工方名称"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人全称">
            <a-input v-model="submitdata.salPolicyHolder.name" :disabled="disabledAll" v-decorator="['submitdata.salPolicyHolder.name', { rules: [{ required: true, message: '请输入投保人全称' }] }]" placeholder="请输入投保人全称" @blur="blurCompanyName()"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }">
            <a-checkbox :disabled="disabledAll" :checked="checkedYZ == 1" @change="onChangeYZ" name="checkbox1"> 同业主 </a-checkbox>
            <a-checkbox :disabled="disabledAll" :checked="checkedYZ == 2" @change="onChangeYZ" name="checkbox2"> 同施工方 </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保人证件类型">
            <a-select
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.idType',
                {
                  rules: [{ required: true, message: '请选择投保人证件类型' }],
                },
              ]"
              placeholder="请选择投保人证件类型"
              @change="blurCompanyName"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保人证件号码">
							<a-input
								v-model="submitdata.salPolicyHolder.idNumber"
								:disabled="true"
								v-decorator="[
									'submitdata.salPolicyHolder.idNumber',
									{
										rules: [{ required: true, message: '请输入投保人证件号码' }],
									},
								]"
								placeholder="请输入投保人证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              v-model="submitdata.salPolicyHolder.contactsname"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.contactsname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              v-model="submitdata.salPolicyHolder.telephone"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.telephone',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              v-model="submitdata.salPolicyHolder.email"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider />
      <!-- 被保险人 -->
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人全称">
            <a-input @change="ttbren = false" :disabled="disabledAll" v-decorator="['submitdata.salInsuredList[0].name', { rules: [{ required: true, message: '请输入被保险人全称' }] }]" placeholder="请输入被保险人全称"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }">
            <a-checkbox :disabled="disabledAll" @change="onChangeConSfid" :checked="ttbren" v-decorator="['submitdata.salInsuredList[0].conSfid']"> 同投保人 </a-checkbox>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人证件类型">
            <a-select
              @change="value => handerIdtype(value)"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].idType',
                {
                  rules: [{ required: true, message: '请选择被保险人证件类型' }],
                },
              ]"
              placeholder="请选择被保险人证件类型"
            >
              <a-select-option v-for="item in bbrenTypeOptions" :key="item.value" :value="item.value">{{ item.name }} </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="被保险人证件号码">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].idNumber',
                {
                  rules: [{ required: true, message: '请输入被保险人证件号码' }],
                },
              ]"
              placeholder="请输入被保险人证件号码"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人姓名">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].linkmanname',
                {
                  rules: [{ required: true, message: '请输入联系人姓名' }],
                },
              ]"
              placeholder="请输入联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人电话">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].mobile',
                {
                  rules: [
                    { required: true, message: '请输入联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="联系人邮箱">
            <a-input
              @change="ttbren = false"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salInsuredList[0].email',
                {
                  rules: [
                    { required: true, message: '请输入联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' },
                  ],
                },
              ]"
              placeholder="请输入联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider />
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="共同被保险人">
            <a-input
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.additionalinsured',
                {
                  rules: [{ required: false, message: '请选择共同被保险人' }],
                },
              ]"
              placeholder="请输入共同被保险人"
            ></a-input>
          </a-form-item>
        </a-col>

        <a-col :span="12">
          <div class="souyiren" style="display: flex">
            <div style="margin-right: 20px">
              <a-select :disabled="disabledAll" :default-value="souyiType" style="width: 180px" v-model="souyiType" @change="souyirenHander">
                <a-select-option value="1"> 本保单第一受益人为 </a-select-option>
                <a-select-option value="2"> 本保单唯一受益人为 </a-select-option>
              </a-select>
            </div>
            <div style="margin-top: -4px">
              <a-form-item :label-col="{ span: 6 }">
                <a-input :disabled="disabledAll" style="width: 300px" v-if="souyiType == '1'" v-decorator="['submitdata.salPolicyHolder.firstbeneficiary']" placeholder="请输入本保单第一受益人"></a-input>
                <a-input :disabled="disabledAll" style="width: 300px" v-if="souyiType == '2'" v-decorator="['submitdata.salPolicyHolder.onlybeneficiary']" placeholder="请输入本保单唯一受益人"></a-input>
              </a-form-item>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="24"> </a-row>
      <!-- 项目信息 -->
      <div class="title_">
        <div class="cutleft_">项目信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="项目名称">
            <a-input
              v-model="submitdata.salPolicyHolder.projectname"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.projectname',
                {
                  rules: [{ required: true, message: '请输入项目名称' }],
                },
              ]"
              placeholder="请输入项目名称"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="工程面积（平米）">
            <a-input
              v-model="submitdata.salPolicyHolder.projectarea"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.projectarea',
                {
                  rules: [{ required: true, message: '请输入工程面积（平米）' }],
                },
              ]"
              placeholder="请输入工程面积"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="工程造价（元）">
            <a-input
              v-model="submitdata.salPolicyHolder.projectamount"
              @blur="onhanderSiSuan(submitdata.salPolicyHolder.projectamount, 'projectamount')"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.projectamount',
                {
                  rules: [{ required: true, message: '请输入工程造价' }],
                },
              ]"
              placeholder="请输入工程造价"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="第三者责任限额（元）" class="aftertext">
            <a-input
              v-model="submitdata.salPolicyHolder.thirdLimit"
              :disabled="disabledAll"
              @blur="onhanderSiSuan(submitdata.salPolicyHolder.thirdLimit, 'thirdLimit')"
              v-decorator="[
                'submitdata.salPolicyHolder.thirdLimit',
                {
                  rules: [{ required: true, message: '请输入第三者责任限额' }, { validator: checkPrice }],
                },
              ]"
              placeholder="请输入第三者责任限额"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="每人赔偿限额">
            <a-select
              placeholder="请选择"
              :disabled="disabledAll"
              @change="value => onhanderSiSuan(value, 'avoirdupois')"
              style="width: 280px"
              class="select_"
              v-decorator="[
                'submitdata.salPolicyHolder.avoirdupois',
                {
                  rules: [{ required: true, message: '请选择每人赔偿限额' }],
                },
              ]"
            >
              <a-select-option v-for="item in oneSCOptions" :key="item.value + 'avoirdupois'" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="工程类型">
            <a-select
              placeholder="请选择"
              :disabled="disabledAll"
              @change="value => onhanderSiSuan(value, 'projectType')"
              style="width: 280px"
              class="select_"
              v-decorator="[
                'projectType',
                {
                  rules: [{ required: true, message: '请选择工程类型' }],
                },
              ]"
            >
              <a-select-option v-for="item in gogncOptions" :key="item.value + 'projectType'" :value="item.value">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="施工地址">
          <a-col :span="12">
            <a-cascader
              placeholder="请选择"
              :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pcCode', label)"
              v-decorator="[
                'pcCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }],
                },
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children',
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              v-model="submitdata.salPolicyHolder.projectaddress"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicyHolder.projectaddress',
                {
                  rules: [{ required: true, message: '请输入详细铺位号/门牌号' }],
                },
              ]"
              placeholder="请输入详细铺位号/门牌号"
              style="float: left; width: 350px; margin-left: 10px"
            ></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <!-- 发票信息 -->
      <div class="title_">
        <div class="cutleft_">开票信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-row>
        <a-row>环保节约，提倡电子发票，如需纸质版本，请自行打印，系统将通过邮件及手机短信发送电子发票，请注意查收。</a-row>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="发票类型">
            <a-select :disabled="disabledAll" placeholder="请选择" @change="invoiceprinttypeChange" v-decorator="['submitdata.salPolicyHolder.invoiceprinttype', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option value="03">暂不开票</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12" v-if="submitdata.salPolicyHolder.invoiceprinttype == '01'">
          <a-form-item :label-col="{ span: 6 }" label="纳税人识别号">
            <a-input :disabled="disabledAll" v-model="submitdata.salPolicyHolder.taxpayercertificateno" v-decorator="['submitdata.salPolicyHolder.taxpayercertificateno', { rules: [{ required: true, message: '请输入纳税人识别号' }] }]" placeholder="请输入纳税人识别号"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="12">
          <a-form-item label="保费" :label-col="{ span: 2 }">
            <a-col :span="6">
              <a-input v-model="submitdata.salPolicy.totalPremium" disabled style="min-width: 130px" addonAfter="元" />
            </a-col>
            <a-col class="btn_list">
              <a-button class="btn_color" :disabled="disabledAll" type="primary" @click="changePremium"> 修改保费 </a-button>
            </a-col>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 4 }" label="支付方式">
            <a-select
              style="width: 100%"
              placeholder="请选择支付类型"
              :disabled="disabledAll"
              v-decorator="[
                'submitdata.salPolicy.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付类型' }],
                },
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px"> 投保人已充分阅读、理解并同意<fileView></fileView> </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmit"> 保存订单 </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="fastInsure">
              立即投保
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="gonOne"> 编辑 </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 修改保费modal -->
    <a-modal v-model="modalVisible" title="修改保费" cancelText="取消" okText="确定" @ok="handleOk">
      <div>
        <div>
          请输入要修改的保费(如不输入则按原值({{ submitdata.salPolicy.totalPremium }})计算)：
          <a-input-number class="level_" :min="parseFloat(submitdata.salPolicy.totalPremium)" v-model="eduitPremium" />
        </div>
      </div>
    </a-modal>
    <!-- 支付的弹窗 -->
    <a-modal class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p style="text-align: center; font-size: 18px; margin-bottom: 0; padding: 20px; line-height: 30px">
        您投保的{{ productName() }}需支付保费 <span style="color: #fe8f2d; font-weight: bold">{{ submitdata.salPolicy.totalPremium }}</span
        >&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import moment from 'moment';
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
export default {
  //import引入的组件需要注入到对象中才能使用
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      formData: {}, //传递数据
      yueduBtn: false, //理解阅读
      saveBtnShow: false, //保存过
      submitLoad1: false, //保存中
      // submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      // companyPropertyList: require("../js/companyPropertyList.json"),
      rate: 0.2, //费率
      industrycodeTEXT: '', //四级行业的文本
      mobilestringcode: '0;0;0;0;0', //每一类添加的保费
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      planinfos: '0;0;0', //基础保费
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      //投保人证件类型
      companyIdTypeOptions: [
        {
          value: '001',
          name: '组织机构代码',
        },
        {
          value: '2',
          name: '税务登记证',
        },
        {
          value: '3',
          name: '营业执照',
        },
      ],
      //被保人证件类型
      bbrenTypeOptions: [
        {
          value: '001',
          name: '组织机构代码',
        },
        {
          value: '2',
          name: '税务登记证',
        },
        {
          value: '3',
          name: '营业执照',
        },
        {
          value: '01',
          name: '身份证',
        },
        {
          value: '03',
          name: '护照',
        },
      ],
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      submitdata: {
        salInsuredList: [
          //被保人集合
          {
            name: '',
            idType: '',
            idNumber: '',
            linkmanname: '',
            mobile: '',
            email: '',
            conSfid: false, //是否同投保人   1:是，0：否
            occupationName: '',
            occulevel: '',
            premium: '',
          },
        ],
        salPolicy: {
          //保单信息
          effectiveDate: '',
          expireDate: '',
          coverageamount: '',
          totalPremium: 0,
          productCode: 'YTJGYQX', //YTJGYQX
          planCode: 'YTJGYQX', //YTJGYQX
          payMethod: '',
          remark: '',
          creator: '',
        },
        salPolicyHolder: {
          //投保人信息
          type: 'C', //固定值
          name: '',
          idType: '',
          idNumber: '',
          contactsname: '',
          telephone: '',
          email: '',
          province: '',
          city: '',
          district: '',
          projectaddress: '',
          projectname: '', //
          proprietorName: '',
          partyName: '',
          projectarea: '',
          projectamount: '',
          thirdLimit: '',
          avoirdupois: '',
          shopsname: '',
          firstbeneficiary: '',
          onlybeneficiary: '',
          additionalinsured: '',
          invoiceprinttype: '',
          taxpayercertificateno: '',
        },
        riskInfos: [
          {
            riskCode: 'projectamount', //工程造价（元）
            amount: 0,
          },
          {
            riskCode: 'thirdLimit', //第三者责任限额（元）
            amount: 0,
          },
          {
            riskCode: 'avoirdupois', //每人赔偿限额
            amount: '1',
          },
          {
            riskCode: 'projectType', //工程类型
            dutyCode: '',
          },
        ],
      }, //测算的数据
      pcCode: [], //省市区的数组
      ployordTime: '', //保单时间
      souyiType: '1', //受益人类型
      checkedYZ: 0, //同业主
      ttbren: false, //同投保人
      projectType: '', //工程类型
      gogncOptions: [
        {
          value: 'shop',
          name: '商铺/办公室室内装修',
        },
        {
          value: 'residential',
          name: '住宅室内装修',
        },
      ],
      eduitPremium: 0, //要修改的保费

      modalVisible: false, //修改保费的弹窗
      CScontent: {},
      ContentView: {}, //展示的保费
      copyCScontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      plan: '',
      userParams: '',
      /**需要的数据结束 */
      planOffsetDay: 0,
      baodanData: {
        startdata: '',
      },
      startValues: null,
      linshiContent: {},
      riskInfosAmount: {}, //计算险种的结果
      ZBAOFEI: 0, //原始保费
      addBAOFEI: 0, //修改添加的保费
      orderContent: {}, //订单的数据
      disabledAll: false, //是否是立即投保
      gztypestr: '',
    };
  },
  //监听属性 类似于data概念
  computed: {
    oneSCOptions() {
      let options = [
        {
          value: '1',
          name: '同每次事故限额',
        },
        {
          value: 200000,
          name: '20万',
        },
        {
          value: 500000,
          name: '50万',
        },
      ];
      if (this.submitdata.salPolicyHolder.thirdLimit == 500000) {
        return options.filter(item => item.value < 500000);
      }
      return options;
    },
    addressOptions() {
      let dataArr = window.addrescode.filter(e => e.value != '990000');
      return dataArr;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    moment,
    productName() {
      return sessionStorage.getItem('productName')
    },
    async blurCompanyName(val) {
      if(val) {
        this.submitdata.salPolicyHolder.idType = val       
      }
      let name = this.submitdata.salPolicyHolder.name
      let type = this.submitdata.salPolicyHolder.idType

      if(!type) {
        this.form.setFieldsValue({
          submitdata: {
            salPolicyHolder: {
              idNumber: '',
            },
          },
        });
        this.submitdata.salPolicyHolder.idNumber = ''
        return
      }
      this.queryCompanyIdNumber(name, type, this.companyIdTypeOptions, 'idNumberFn');
    },
    idNumberFn(code){
      this.form.setFieldsValue({
        submitdata: {
          salPolicyHolder: {
            idNumber: code,
          },
        },
      });
      this.submitdata.salPolicyHolder.idNumber = code
      this.$forceUpdate()
    },
    //理解并阅读
    onChangeyueduBtn(e) {
      this.yueduBtn = e.target.checked;
    },
    //校验第三责任金额
    checkPrice(rule, value, callback) {
      if (value >= 500000) {
        callback();
        return;
      }
      callback('第三者责任限额最低50万起保!');
    },
    //同业主
    onChangeYZ(e) {
      
      if (e.target.name == 'checkbox1') {
        this.checkedYZ = this.checkedYZ == 1 ? 0 : 1;
        this.form.setFieldsValue({
          submitdata: {
            salPolicyHolder: {
              name: this.submitdata.salPolicyHolder.proprietorName,
            },
          },
        });
        this.submitdata.salPolicyHolder.name = this.submitdata.salPolicyHolder.proprietorName;
      }
      if (e.target.name == 'checkbox2') {
        this.checkedYZ = this.checkedYZ == 2 ? 0 : 2;
        this.form.setFieldsValue({
          submitdata: {
            salPolicyHolder: {
              name: this.submitdata.salPolicyHolder.partyName,
            },
          },
        });
        this.submitdata.salPolicyHolder.name = this.submitdata.salPolicyHolder.partyName;
      }
    },
    //同投保人
    onChangeConSfid(e) {
      
      this.ttbren = e.target.checked;
      if (this.ttbren) {
        this.form.setFieldsValue({
          submitdata: {
            salInsuredList: [
              {
                name: this.submitdata.salPolicyHolder.name,
                idType: this.submitdata.salPolicyHolder.idType,
                idNumber: this.submitdata.salPolicyHolder.idNumber,
                linkmanname: this.submitdata.salPolicyHolder.contactsname,
                mobile: this.submitdata.salPolicyHolder.telephone,
                email: this.submitdata.salPolicyHolder.email,
              },
            ],
          },
        });
      }
    },
    //触发试算
    onhanderSiSuan(value, type) {
      
      
      if (!value || !type) return;
      if (type == 'avoirdupois') {
        this.submitdata.salPolicyHolder.avoirdupois = value;
      }
      if (type == 'thirdLimit') {
        if (Number(value) < 500000) {
          return;
        }
      }
      if (type == 'projectType') {
        this.projectType = value;
      }
      if (Number(this.submitdata.salPolicyHolder.projectamount || 0) + Number(this.submitdata.salPolicyHolder.thirdLimit || 0) > 30000000) {
        this.$message.warning('本产品工程造价+三责限额，累计不得超过3000万元!');
        this.$nextTick(() => {
          this.form.setFieldsValue({
            submitdata: {
              salPolicyHolder: {
                thirdLimit: 0,
              },
            },
          });
          this.submitdata.salPolicyHolder.thirdLimit = 0;
        });
        return;
      }
      this.resultPremiumSum();
    },
    //时间改变
    onChangeTime(value, dateString) {
      
      
      this.ployordTime = dateString;
      this.submitdata.salPolicy.effectiveDate = value[0];
      this.submitdata.salPolicy.expireDate = value[1];
      let end = moment(value[1]).subtract(0, 'days');
      let offsetDay = end.diff(value[0], 'days');
      this.planOffsetDay = offsetDay;
      this.resultPremiumSum();
    },
    handerIdtype(value) {
      this.ttbren = false;
      this.submitdata.salInsuredList[0].idType = value;
    },
    //时间限制
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current < currents || current > moment(currents).add(1, 'year');
    },
    souyirenHander(value) {
      
      this.souyiType = value;
    },
    gonOne() {
      this.disabledAll = false;
      this.addBAOFEI = this.$accuracy.sub(this.submitdata.salPolicy.totalPremium, this.ZBAOFEI);
      
      this.$bus.$emit('disabledBus', false);
      this.$router.push({
        name: 'ytjg',
        query: {
          u: this.$route.query.u,
          p: this.$route.query.p,
          sign: this.$route.query.sign,
          planCode: this.$route.query.planCode,
        },
      });
    },
    //打开文件列表
    fileListClick() {
      this.$store.commit('setNotShow', true);
    },
    //判断是否有多种类别
    checkBaseList(list) {
      return list.filter(e => e.personNum > 0).length > 0;
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId,
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            this.$store.commit('setOrderContent', this.orderContent);
            this.form.setFieldsValue({
              submitdata: res.data.content,
            });
            if (res.data.content.salInsuredList) {
              let salInsuredList = res.data.content.salInsuredList;
              this.ttbren = salInsuredList[0].conSfid == '1' ? true : false;
            }
            if (res.data.content.riskInfos) {
              this.projectType = res.data.content.riskInfos.filter(item => item.riskCode == 'projectType')[0].dutyCode;
              this.form.setFieldsValue({
                projectType: res.data.content.riskInfos.filter(item => item.riskCode == 'projectType')[0].dutyCode,
              });
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.submitdata.salPolicy.payMethod = salPolicy.payMethod;
              this.form.setFieldsValue({
                ployordTime: [salPolicy.effectiveDate ? moment(new Date(salPolicy.effectiveDate), 'YYYY-MM-DD') : '', salPolicy.expireDate ? moment(new Date(salPolicy.expireDate), 'YYYY-MM-DD') : ''],
              });
              this.ployordTime = [salPolicy.effectiveDate ? moment(new Date(salPolicy.effectiveDate), 'YYYY-MM-DD') : '', salPolicy.expireDate ? moment(new Date(salPolicy.expireDate), 'YYYY-MM-DD') : ''];
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.form.setFieldsValue({
                pcCode: [salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district],
              });
              this.pcCode = [salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district];
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  submitdata: {
                    salPolicyHolder: {
                      taxpayercertificateno: salPolicyHolder.taxpayercertificateno,
                    },
                  },
                });
                if (salPolicyHolder.onlybeneficiary) {
                  this.souyiType = '2';
                } else {
                  this.souyiType = '1';
                }
              });
            }
            for (const key in this.submitdata) {
              this.submitdata[key] = { ...res.data.content[key] };
            }
            
            this.formData = this.submitdata;
            this.resultPremiumSum('eduit');
          }
        }
      });
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
          sessionStorage.setItem('pacCode', threeArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]],
        };
      }
    },
    Filtergztypestr(data) {
      let newData = data.split(';').slice(8, -1);
      let obj = {};
      newData.forEach((e, i) => {
        obj[i + 1] = e;
      });
      return obj;
    },
    //确认修改
    handleOk() {
      this.submitdata.salPolicy.totalPremium = this.eduitPremium;
      // let numResult = 0;
      // //
      // let sumZfeiyong = this.sumZfeiyong(this.copyCScontent, this.riskNumber);
      // 
      // Object.values(sumZfeiyong).forEach((e) => {
      //   numResult += e;
      // });
      // 
      // this.addBAOFEI = this.$accuracy.sub(numResult, this.ZBAOFEI);
      // this.submitdata.salPolicy.totalPremium = numResult.toFixed(2);
      // this.CScontent = this.copyCScontent;
      this.modalVisible = false;
      // this.gztypestr = "";
      // this.Eachbaofei(this.ContentView, this.CScontent);
    },
    //每一类添加的保费
    Eachbaofei(val, newVal) {
      let num1 = this.$accuracy.sub(Number(newVal[1]), Number(val[1])) || 0;
      let num2 = this.$accuracy.sub(Number(newVal[2]), Number(val[2])) || 0;
      let num3 = this.$accuracy.sub(Number(newVal[3]), Number(val[3])) || 0;
      let num4 = this.$accuracy.sub(Number(newVal[4]), Number(val[4])) || 0;
      this.mobilestringcode = [num1, num2, num3, num4].join(';');
    },
    //修改保费
    changePremium() {
      if (!this.submitdata.salPolicy.totalPremium) {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    //反转对象
    resoverObj(obj) {
      var a = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        // 5: 0,
        // 6: 0,
      };
      for (const key in obj) {
        a[key] = obj[key];
      }
      return a;
    },
    //统计次数
    numResult(data) {
      
      var d = [];
      var b = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        // 5: 0,
        // 6: 0,
      };
      data.forEach(e => {
        let levelF = Number(e.occulevel.toString().slice(0, 1));
        if (b[levelF] !== undefined) {
          b[levelF] += 1;
        }
      });
      for (const key in b) {
        var c = {
          occupationKind: '',
          personNum: 0,
        };
        c.occupationKind = key;
        c.personNum = b[key];
        d.push(c);
      }
      
      return d;
    },
    //处理险种的拼接字段
    perRiskInfoNew(perRiskInfo) {
      var arrperRiskInfo = [];
      perRiskInfo.forEach(e => {
        if (e.riskCode == 'GSSGCJ' && e.amount > 0) {
          arrperRiskInfo.push('10-工伤身故、残疾-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'GSSGYL' && e.amount > 0) {
          arrperRiskInfo.push('11-工伤事故医疗费用-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'TZSBFWW' && e.amount > 0) {
          arrperRiskInfo.push('55-扩展社保范围外医疗费用-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == '24HYWXTB' && e.amount > 0) {
          arrperRiskInfo.push('44-24小时意外险特别扩展条款-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'YWZYJTMC' && e.amount > 0) {
          arrperRiskInfo.push('22-意外住院津贴每次事故-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'WGF' && e.amount > 0) {
          arrperRiskInfo.push('33-误工费-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'YCXSCJY' && e.amount > 0) {
          arrperRiskInfo.push('66-一次性伤残就业补助金-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'SHHLF' && e.amount > 0) {
          arrperRiskInfo.push('77-生活护理费-' + e.amount + '-' + e.premiumAmt);
        }
        if (e.riskCode == 'GSDCGPF' && e.amount > 0) {
          arrperRiskInfo.push('100-工伤定残高赔付标准-' + e.amount + '-' + e.premiumAmt);
        }
      });
      
      return arrperRiskInfo.join('#');
    },
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //测算的总价格
    cesuannum(data) {
      var a = {};
      var resultnum = 0;
      this.submitdata.premiumBaseDtoList.forEach(e => {
        a[e.occupationKind] = e.personNum;
      });
      for (const key in a) {
        
        resultnum += a[key] * data[key];
      }
      
      return resultnum.toFixed(2);
    },
    //试算的接口
    resultPremiumSum: function (type) {
      let formData = {
        riskInfos: [
          {
            riskCode: 'projectamount', //工程造价（元）
            amount: this.submitdata.salPolicyHolder.projectamount,
          },
          {
            riskCode: 'thirdLimit', //第三者责任限额（元）
            amount: this.submitdata.salPolicyHolder.thirdLimit,
          },
          {
            riskCode: 'avoirdupois', //每人赔偿限额
            amount: this.submitdata.salPolicyHolder.avoirdupois,
          },
          {
            riskCode: 'projectType', //工程类型
            dutyCode: this.projectType,
          },
        ], //险种信息
        salPolicy: {
          planCode: this.plan, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          bracket: '', //保费期限
          effectiveDate: this.submitdata.salPolicy.effectiveDate ? new Date(this.submitdata.salPolicy.effectiveDate) : '',
          expireDate: this.submitdata.salPolicy.expireDate ? new Date(this.submitdata.salPolicy.expireDate) : '',
        },
        salPolicyExt: {
          isworkheightinvolved: '2',
          occEmpVersion: '',
        },
        salPolicyHolder: {
          addfifty: '2', // 测算类型
          stature: '2', //是否高空（2-否，1-是）
          projectamount: this.submitdata.salPolicyHolder.projectamount,
          thirdLimit: this.submitdata.salPolicyHolder.thirdLimit,
          avoirdupois: this.submitdata.salPolicyHolder.avoirdupois,
        },
      };
      this.submitdata.riskInfos = formData.riskInfos;
      this.formData = formData;
      this.$parent.$refs.riskInfo.busOnDataMethod();
      if (this.submitdata.salPolicyHolder.projectamount && this.submitdata.salPolicyHolder.thirdLimit && this.submitdata.salPolicyHolder.avoirdupois && this.projectType && this.ployordTime) {
        if (type == 'eduit') {
          return;
        }
        if (Number(this.submitdata.salPolicyHolder.thirdLimit) < 500000) {
          return;
        }
        this.$api.calPremiumEmployer(formData).then(res => {
          if (res.data.success) {
            let datas = res.data.content;
            if (datas && datas > 0) {
              if (datas < 500) {
                this.$message.warning('本产品最低收费500元!');
                this.submitdata.salPolicy.totalPremium = 500;
              } else {
                this.submitdata.salPolicy.totalPremium = datas;
              }
              this.eduitPremium = this.submitdata.salPolicy.totalPremium;
            }
          } else {
            this.$message.error(res.data.returnMsg + '错误');
          }
        });
      }
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.submitdata.salPolicyHolder.invoiceprinttype = value;
    },
    //提交的去重
    unique(arr, attribute) {
      var new_arr = [];
      var json_arr = [];
      for (var i = 0; i < arr.length; i++) {
        if (new_arr.indexOf(arr[i][attribute]) == -1) {
          //  -1代表没有找到
          new_arr.push(arr[i][attribute]); //如果没有找到就把这个name放到arr里面，以便下次循环时用
          json_arr.push(arr[i]);
        }
      }
      return json_arr;
    },
    salInsuredList(data) {
      data.forEach(e => {
        
        if (e['gender'] == '男' || e['gender'] == 'M') {
          e['gender'] = 'M';
        } else {
          e['gender'] = 'F';
        }
        let leiocc = Number(e.occulevel.toString().slice(0, 1));
        e['occulevel'] = Number(e.occulevel.toString().slice(0, 1));
        
        e['premium'] = Number(this.copyCScontent[leiocc]);
      });
      return data;
    },
    //计算总保费
    countTimes(data) {
      
      var a = [];
      if (data.length) {
        data.forEach(e => {
          let leve = e.occulevel.toString().indexOf('类') > -1 ? Number(e.occulevel.toString().slice(0, 1)) : Number(e.occulevel);
          a.push(leve);
        });
        return a.reduce(function (time, name) {
          if (name in time) {
            time[name]++;
          } else {
            time[name] = 1;
          }
          return time;
        }, {});
      } else {
        return {
          1: 0,
          2: 0,
          3: 0,
          4: 0,
        };
      }
    },
    //计算总保费
    sumZfeiyong(content, riskNumber) {
      var jichu = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
      };
      for (const key in content) {
        jichu[key] = content[key] * riskNumber[key] || 0;
      }
      
      return jichu;
    },
    //计算费率
    sumrate(isHighWork, data, bracket) {
      
      var a = [];
      data.forEach(e => {
        a.push(e.occulevel.toString().slice(0, 1));
      });
      this.maxType = Math.max(...a);
      var is45 = a.some(val => {
        return val == '4' || val == '5';
      });
      if (is45 || isHighWork == '1') {
        let rate = {
          1: 0.4,
          3: 0.4,
          6: 0.7,
          12: 1.0,
        };
        this.rate = rate[bracket];
      } else {
        let rate = {
          1: 0.2,
          3: 0.4,
          6: 0.7,
          12: 1.0,
        };
        this.rate = rate[bracket];
      }
    },
    //拼接gztypestr字段
    gztypestrPin() {
      var a = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
      };
      delete this.CScontent['perRiskInfo'];
      for (const key in this.CScontent) {
        a[key] = this.CScontent[key];
      }
      let baofei = Object.values(a).join(';'); //总保费
      this.planinfos = Object.values(a).slice(0, 3).join(';'); //基础保费
      
      let b = [];
      this.maxType = Math.max(...b);
      var arr = [
        2,
        12,
        this.maxType,
        0, //费率
        this.industrycodeTEXT || '',
        0,
        baofei,
      ];
      
      return arr.join(';');
    },
    //计算数组之和
    sumarr(arr) {
      return Object.values(arr).reduce(function (prev, cur) {
        return this.$accuracy.add(Number(prev), Number(cur));
      });
    },
    //处理险种信息
    filterRiskInfo(data) {
      
      data.forEach(e => {
        if (e.dutyCode == '631001' && e.riskCode == '060099') {
          e.premiumAmt = this.$accuracy.add(Number(this.riskInfosAmount[e.dutyCode] || 0), this.addBAOFEI);
        } else {
          e.premiumAmt = this.riskInfosAmount[e.dutyCode] || 0;
        }
      });
      
      return data.filter(item => item.amount > 0);
    },
    //最后的提交
    handleSubmit() {
      let ageStatus = true;
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        
        
        if (!err) {
          let data = {
            salInsuredList: [
              {
                name: values.submitdata.salInsuredList[0].name,
                idType: values.submitdata.salInsuredList[0].idType,
                idNumber: values.submitdata.salInsuredList[0].idNumber,
                linkmanname: values.submitdata.salInsuredList[0].linkmanname,
                mobile: values.submitdata.salInsuredList[0].mobile,
                email: values.submitdata.salInsuredList[0].email,
                conSfid: values.submitdata.salInsuredList[0].conSfid ? 1 : 0, //是否同投保人   1:是，0：否
                occupationName: '',
                occulevel: '',
                premium: '',
              },
            ],
            salPolicy: {
              //保单信息
              effectiveDate: this.submitdata.salPolicy.effectiveDate ? new Date(this.submitdata.salPolicy.effectiveDate) : '',
              expireDate: this.submitdata.salPolicy.expireDate ? new Date(this.submitdata.salPolicy.expireDate) : '',
              coverageamount: '',
              id: this.policyId,
              totalPremium: this.submitdata.salPolicy.totalPremium,
              productCode: this.$route.query.p, //YTJGYQX
              planCode: this.$route.query.p, //YTJGYQX
              payMethod: values.submitdata.salPolicy.payMethod,
              remark: values.submitdata.salPolicy.remark,
              creator: this.$route.query.u,
            },
            salPolicyExt: {
              isworkheightinvolved: '2', //是否高空作业
              occEmpVersion: '',
              occuRiskPremium: '',
            },
            salPolicyHolder: {
              //投保人信息
              type: 'C', //固定值
              name: values.submitdata.salPolicyHolder.name,
              idType: values.submitdata.salPolicyHolder.idType,
              idNumber: values.submitdata.salPolicyHolder.idNumber,
              contactsname: values.submitdata.salPolicyHolder.contactsname,
              telephone: values.submitdata.salPolicyHolder.telephone,
              email: values.submitdata.salPolicyHolder.email,
              province: this.pcCode[0], //省
              city: this.pcCode[1], //市
              district: this.pcCode[2], //区
              projectaddress: values.submitdata.salPolicyHolder.projectaddress,
              projectname: values.submitdata.salPolicyHolder.projectname, //
              proprietorName: values.submitdata.salPolicyHolder.proprietorName,
              partyName: values.submitdata.salPolicyHolder.partyName,
              projectarea: values.submitdata.salPolicyHolder.projectarea,
              projectamount: values.submitdata.salPolicyHolder.projectamount,
              thirdLimit: values.submitdata.salPolicyHolder.thirdLimit,
              avoirdupois: values.submitdata.salPolicyHolder.avoirdupois,
              shopsname: values.submitdata.salPolicyHolder.shopsname,
              firstbeneficiary: values.submitdata.salPolicyHolder.firstbeneficiary,
              onlybeneficiary: values.submitdata.salPolicyHolder.onlybeneficiary,
              additionalinsured: values.submitdata.salPolicyHolder.additionalinsured,
              invoiceprinttype: values.submitdata.salPolicyHolder.invoiceprinttype,
              taxpayercertificateno: values.submitdata.salPolicyHolder.taxpayercertificateno,
            },
            riskInfos: this.submitdata.riskInfos,
          };
          
          this.postPolicyData = data;
          if (this.$route.query.policyId) {
            this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
          }
          this.$store.commit('setproductCode', this.productCode);
          if (this.submitdata.salPolicy.totalPremium <= 0) {
            this.$warning({
              title: '温馨提示',
              content: '工程类型为必选项，请选择后再次进行保存',
              okText: '知道了',
            });
            return;
          }
          this.submitLoad1 = true;
          this.axiosPolicy(); // 保存订单是 直接保存
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    //立即投保
    fastInsure() {
      if (!this.yueduBtn) {
        this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
        return;
      }
      this.$store.commit('setLoading', {
        show: true,
        text: '核保中，请稍后...',
      });
      this.$api
        .yaTaiConstruction(this.$route.query.policyId)
        .then(res => {
          if (res.data.returnCode == '0000') {
            this.$message.success('核保成功！', 2);
            this.submitdata.salPolicy.totalPremium = res.data.content;
            this.showPaySure = true;
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', { show: false });
        });
    },
    axiosPolicy() {
      //提交保单
      this.$api
        .addPAPolicy(this.postPolicyData)
        .then(res => {
          if (res.data.returnCode == '00') {
            
            this.showPaySure = false;
            this.saveBtnShow = true;
            this.policyId = res.data.content;
            this.$message.success('保存成功！');
            this.$router.push({
              name: 'ytjg',
              query: {
                u: this.$route.query.u,
                p: this.$route.query.p,
                sign: this.$route.query.sign,
                policyId: this.policyId,
                planCode: this.$route.query.planCode,
                continuation: '1'
              },
            });
            this.disabledAll = true;
            this.$bus.$emit('disabledBus', true);
          }
        })
        .finally(() => {
          this.submitLoad1 = false;
        });
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'ytjg', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.submitdata.salPolicy.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.submitdata.salPolicy.totalPremium, //支付总金额
        name: this.submitdata.salPolicy.name
      });
    },
    handleChange(value, type) {
      if (type == 'pcCode') {
        this.pcCode = value;
      }
    },
    busDataMethod() {
      let strdata = this.$lodash.cloneDeep(this.$parent.$refs.riskInfo.allData);
      
      this.projectType = strdata.riskInfos.filter(item => item.riskCode == 'projectType')[0].dutyCode;
      this.submitdata.salPolicyHolder.projectamount = strdata.salPolicyHolder.projectamount;
      this.submitdata.salPolicyHolder.thirdLimit = strdata.salPolicyHolder.thirdLimit;
      this.submitdata.salPolicyHolder.avoirdupois = strdata.salPolicyHolder.avoirdupois || undefined;

      this.form.setFieldsValue({
        submitdata: {
          salPolicyHolder: {
            projectamount: strdata.salPolicyHolder.projectamount,
            thirdLimit: strdata.salPolicyHolder.thirdLimit,
            avoirdupois: strdata.salPolicyHolder.avoirdupois || undefined,
          },
        },
        projectType: strdata.riskInfos.filter(item => item.riskCode == 'projectType')[0].dutyCode,
      });
      if (strdata.salPolicy.effectiveDate && strdata.salPolicy.expireDate) {
        this.form.setFieldsValue({
          ployordTime: [moment(strdata.salPolicy.effectiveDate, 'YYYY-MM-DD'), moment(strdata.salPolicy.expireDate, 'YYYY-MM-DD')],
        });
        this.submitdata.salPolicy.effectiveDate = moment(strdata.salPolicy.effectiveDate, 'YYYY-MM-DD');
        this.submitdata.salPolicy.expireDate = moment(strdata.salPolicy.expireDate, 'YYYY-MM-DD');
        this.ployordTime = [moment(strdata.salPolicy.effectiveDate, 'YYYY-MM-DD'), moment(strdata.salPolicy.expireDate, 'YYYY-MM-DD')];
      }
      
      if (this.agreementRead) {
        this.resultPremiumSum();
      }
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.btn_color {
  margin: 0 20px;
}
.aftertext {
  position: relative;
}
.aftertext::after {
  content: '500000元起保';
  position: absolute;
  color: #999999;
  top: 10px;
  right: 50px;
  z-index: 2;
}
</style>
